<template>
  <div class="schedulesmslogVue">
    <!-- Main Body Content area -->
        <div class="o-main-content-area">
            <!-- Heading Section -->
            <div class="o-page-top-heading c-responsive-fixwidth">
                <div class="row c-responsive-fixwidth">
                    <div class="col-md-9">
                        <p class="u-back"><a href="javascript: void(0)" @click="backToSchedule()"><i class="fa fa-chevron-left"></i> Back</a></p>
                    </div>
                    <div class="col-md-3">
                        <div class="input-group stylish-input-group" style="visibility:hidden;">
                            <input type="text" class="form-control" placeholder="Search">
                            <span class="input-group-addon">
                            <button type="submit">
                                <span class=""><i class="fa fa-search" aria-hidden="true"></i></span>
                            </button>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="row c-responsive-fixwidth">
                    <div class="col-md-12">
                        <h1 class="h1" style="display: inline;">Client SMS Log:</h1>
                        <p class="pt-1"><strong>Note: </strong> You are getting the timestamp in the local time zone, billing will be generated with respect to the UTC</p>
                        <!-- <div style="display: inline; float: right;">
                            <a href="javascript: void(0)" @click="csvDownload()" class="c-common-btn c-common-btn--small"><i class="fa fa-download" aria-hidden="true"></i> Download CSV</a>
                        </div> -->
                        <!-- <h3 class="h3" v-if="getActionType == 'employeeAction'">{{employeeName}}</h3> -->
                    </div>
                </div>

            </div>
            <!-- /Heading Section -->
        </div>
        <!-- /Main Body Content area -->

        <!-- Individual calls section area -->
        <div class="o-ndividualArea c-responsive-fixwidth">
            <div v-loading="loading" class="o-ndividualTable">
               
                <div v-for="(sms,index) in smsLogList" :key="index" class="o-custom-table-container c-common-box-shadow c-radius3 sms-list-table-align o-overflow-visible">
                    <div class="o-calls-table c-common-gradient o-overflow-visible tableList-padding">
                        <div class="calls-table-row phonesheet-table-row">
                  
                            <div class="calls-table-cell">
                                <div class="table-td-border-right">
                                    <div class="calls-table-cell-inner-table">
                                        <div class="o-accordion-subtext o-rowtable-text">
                                            <span>Sr. No:</span>
                                            <div>{{ index + 1 }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="calls-table-cell">
                                <div class="table-td-border-right">
                                    <div class="calls-table-cell-inner-table">
                                        <div class="o-accordion-subtext o-rowtable-text">
                                            <span>Timestamp:</span>
                                            <div>{{getGlobalDateTimeFormat(sms.receiveTime)}}<!-- {{(sms.notifiable && sms.notifiable.employable)?sms.notifiable.employable.created_at:''}} --></div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="calls-table-cell">
                                <div class="table-td-border-right">
                                    <div class="calls-table-cell-inner-table">
                                        <div class="o-accordion-subtext o-rowtable-text">
                                            <span>Sent To:</span>
                                            <div>{{ sms.destinationTn }}</div>
                                            <div>{{ sms.name }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- <div class="calls-table-cell">
                                <div class="table-td-border-right">
                                    <div class="o-accordion-subtext o-rowtable-text">
                                        <span>Type:</span>
                                        <div>{{sms.type}}</div>
                                    </div>
                                </div>
                            </div> -->
                            <!-- <div class="calls-table-cell">
                                <div class="table-td-border-right">
                                    <div class="o-accordion-subtext o-rowtable-text">
                                        <span>Content:</span>
                                        <div>
                                            <a href="javascript: void(0)" class="o-tooltip-trigger">
                                                
                                                <div class="tooltip c-common-box-shadow">
                                                    {{sms.content}}
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div> -->
                            <div class="calls-table-cell">
                                <div class="table-td-border-right">
                                    <div class="calls-table-cell-inner-table">
                                        <div class="o-accordion-subtext o-rowtable-text">
                                            <span>Length:</span>
                                            <div>{{ sms.content.length }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            

                            <div class="calls-table-cell">
                                <div class="table-td-border-right">
                                    <div class="calls-table-cell-inner-table">
                                        <div class="o-accordion-subtext o-rowtable-text">
                                            <span>Segments:</span>
                                            <div>{{ sms.segmentCount }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- <div class="calls-table-cell">
                                <div class="table-td-border-right">
                                    <div class="o-accordion-subtext o-rowtable-text">
                                        <span>Status:</span>
                                        <div>{{(sms.notifiable && sms.notifiable.employee_status)?sms.notifiable.employee_status.name:''}}</div>
                                    </div>
                                </div>
                            </div> -->
                            <div class="calls-table-cell">
                                <div class="">
                                    <div class="o-accordion-subtext o-rowtable-text">
                                        <!-- <span>Server Response:</span> -->
                                        <span>Status:</span>
                                        <div>{{sms.messageStatus}}</div>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>   
                <div v-if="smsLogList.length <= 0 && apiData" class="c-common-space c-common-gradient c-common-box-shadow c-radius3">
                   <div class="col-md-12 no-job-dispaly">
                      <i class="fa fa-frown-o" aria-hidden="true"></i>
                      <br />
                       No Data Stored
                   </div>
                  </div>
                                  
            </div>          
        </div>

        <!-- /Individual calls section area -->
  </div>
</template>

<script>
    import {
        VueEditor
    } from 'vue2-editor';
    import service from '../services.js';
    import {
        global
    } from '../global.js';
    import dateTimeConvert from '../timeConvert&Compare';
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    export default {
        components: {
            VueEditor
        },
        data() {
            return {
                loading:false,
                apiData:false,
                smsLogList: [],
                nextPageUrl: '',
                storeMore: [],
                employeeName:'',
                userDateFormat:null,
                userTimeFormat:null
            }
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userClientID: 'userClientID',
                employeeId: 'employeeId',
                getActionType: 'getNotificationType',
                job: 'getJob',
                //jobID: 'selectedJobId',
            })
        },
        methods: {
            getEmpDetails() {
                this.$Progress.start();
                service.get('employee/' + this.employeeId, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                })
                .then((res) => {
                    this.$Progress.finish();
                    this.employeeName=res.data.result.employable.first_name+" "+res.data.result.employable.last_name;
                    this.userDateFormat=res.data.result.date_format;
                    this.userTimeFormat=res.data.result.time_format;
                    //this.detailEmployee = res.data.result;
                    //console.log('UserID',this.userId);
                    // console.log(this.userDateFormat,this.userTimeFormat);
                }).catch((err) => {
                    console.log(err);
                });
            },
            backToSchedule() {
              this.$router.go(-1);
            },
            getTimeStamp(dateTime) {
                if (dateTime != 'undefined') {
                    return dateTimeConvert.utcTimeToUserTime(dateTime);
                    //return moment.utc(dateTime).tz(this.$cookies.get('time_zone')).format('YYYY/MM/DD @ hh:mm A');
                }
            },

            getGlobalDateTimeFormat(data) {
                return dateTimeConvert.globalDateTime2(data,this.userDateFormat,this.userTimeFormat);
            },
           
            csvDownload(){
                this.$Progress.start();
                let path = '';
                let header = {};
                    path = 'client/getBandwidthLog';
                    header = {
                        'Authorization': this.userToken,
                        'cs3-context-clientid': this.userClientID,
                    };
                service.get(path, header).then((res) => {
                    this.$Progress.finish();
                    // console.log(res.data.result);
                    this.JSONToCSVConvertor(res.data.result, "SMS Log", true);                    
                }).catch((err) => {
                    console.log(err);
                });
            },
            JSONToCSVConvertor(JSONData, ReportTitle, ShowLabel) {
                var arrData = typeof JSONData != 'object' ? JSON.parse(JSONData) : JSONData;

                var CSV = '';
                //Set Report title in first row or line

                CSV += ReportTitle + '\r\n\n';

                //This condition will generate the Label/Header
                if (ShowLabel) {
                    var row = "";

                    //This loop will extract the label from 1st index of on array
                    for (var index in arrData[0]) {

                        //Now convert each value to string and comma-seprated
                        row += index + ',';
                    }

                    row = row.slice(0, -1);

                    //append Label row with line break
                    CSV += row + '\r\n';
                }

                //1st loop is to extract each row
                for (var i = 0; i < arrData.length; i++) {
                    var row = "";

                    //2nd loop will extract each column and convert it in string comma-seprated
                    for (var index in arrData[i]) {
                        row += '"' + arrData[i][index] + '",';
                    }

                    row.slice(0, row.length - 1);

                    //add a line break after each row
                    CSV += row + '\r\n';
                }

                if (CSV == '') {
                    alert("Invalid data");
                    return;
                }

                //Generate a file name
                var fileName = "CS3_";
                //this will remove the blank-spaces from the title and replace it with an underscore
                fileName += ReportTitle.replace(/ /g, "_");

                //Initialize file format you want csv or xls
                var uri = 'data:text/csv;charset=utf-8,' + escape(CSV);

                // Now the little tricky part.
                // you can use either>> window.open(uri);
                // but this will not work in some browsers
                // or you will not get the correct file extension

                //this trick will generate a temp <a /> tag
                var link = document.createElement("a");
                link.href = uri;

                //set the visibility hidden so it will not effect on your web-layout
                link.style = "visibility:hidden";
                link.download = fileName + ".csv";

                //this part will append the anchor tag and remove it after automatic click
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        },
        created() {
            this.getEmpDetails();
            let path = '';
            let header = {};
            // if (this.getActionType == 'clientAction') {
                path = 'client/bandwidthMonthyLogDetails';
                header = {
                    'Authorization': this.userToken,
                    'cs3-context-clientId': this.userClientID,
                };
                // console.log(path,header);
            // } else {
            // }
            this.loading=true;
            this.apiData=false;
            service.get(path, header).then((res) => {
                this.loading=false;
                this.apiData=true;
                this.smsLogList = res.data.messages ? res.data.messages : [];
                this.$Progress.finish();
                //console.log(this.employees);
            }).catch((err) => {
                console.log(err);
                this.loading=false;
                this.apiData=true;
                this.$Progress.finish();
            });
        }
    }

</script>
<style scoped>
.pt-1 {
    padding-top: 1rem!important;
}

</style>
